module.exports = __webpack_public_path__ + "static/media/koss-ksc75.54e845de.jpg";